export default __webpack_public_path__ + "static/media/i208jk.25655b4e.webp";